// extracted by mini-css-extract-plugin
export default {"roundIcon":"VSHUSqF9l45NV1GArt6W","roundIcon__figure":"LnHvoFRfvK9LMmmAZge1","roundIconFigure__wrapper":"AaWvAopIEDWMj2MwX9lN"};